import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-xs text-foreground-500">
      <ol className="flex items-center gap-2 flex-wrap">
        {items.map((item, index) => (
          <li key={item.label} className="flex items-center gap-2">
            {item.to ? (
              <Link to={item.to} className="hover:text-primary-600 transition-colors cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800" aria-current="page">
                {item.label}
              </span>
            )}
            {index < items.length - 1 && (
              <span className="w-3.5 h-3.5 flex items-center justify-center text-foreground-400">
                <i className="ri-arrow-right-s-line" />
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}